import { render } from "./iq-card.vue?vue&type=template&id=7b0d3db8"
import script from "./iq-card.vue?vue&type=script&lang=js"
export * from "./iq-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__